var React = require('react');

function RectangleTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M86.1701 90.5263L122.894 2.51456L178.34 142.103L86.1701 90.5263Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M3.52532 93.0516L123.031 2.50991L86.3172 90.3913L3.52532 93.0516Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M3.52734 93.0527L86.2609 90.3942L178.34 142.104L3.52734 93.0527Z","fill":"#5915C7","key":2})]);
}

RectangleTriangle.defaultProps = {"width":"179","height":"148","viewBox":"0 0 179 148","fill":"none"};

module.exports = RectangleTriangle;

RectangleTriangle.default = RectangleTriangle;
